import React from 'react';
import { Cascader } from '@firesoon/antd';
import './index.less';

const Index = (props: any) => {
  return (
    <Cascader
      displayRender={(label) => label.join(' > ')}
      className="fs-cascader-picker"
      popupClassName="fs-cascader-menus"
      {...props}
    />
  );
};

export default Index;
